import { Box, Typography } from '@material-ui/core';
import { useCallback, useEffect, useState } from 'react';
import { useNotify } from 'react-admin';
import { useLocation } from 'react-router-dom';
import {
  useQuizAssessmentTestDataProvider
} from '../../../../providers/data-provider/quiz-assessment-test.data.provider';
import { AnsweringStep } from './answering-step';
import { BlockedStep } from './blocked-step';
import { Phase } from './constants';
import { SearchStep } from './search-step';
import { useStyles } from './styles';
import { SuccessStep } from './success-step';

export function MQuizAssessmentSaveResult() {
  const classes = useStyles();
  const notify = useNotify();
  const location = useLocation();
  const { getTestDetails, getTestAnswerKey } = useQuizAssessmentTestDataProvider();

  const [phase, setPhase] = useState(Phase.SEARCH);
  const [testCode, setTestCode] = useState('');
  const [searching, setSearching] = useState(false);
  const [testInfo, setTestInfo] = useState(null);
  const [answerKey, setAnswerKey] = useState([]);
  const [result, setResult] = useState(null);

  const resetToSearch = useCallback(() => {
    setPhase(Phase.SEARCH);
    setTestCode('');
    setTestInfo(null);
    setAnswerKey([]);
    setResult(null);
  }, []);

  const searchByCode = useCallback((code) => {
    if (!code) return;
    setSearching(true);
    getTestDetails(code).then((res) => {
      const info = res.data;
      setTestInfo(info);
      if (info.status !== 'started') {
        setPhase(Phase.BLOCKED);
        return;
      }

      return getTestAnswerKey(code).then((answerRes) => {
        setAnswerKey(answerRes.data);
        setPhase(Phase.ANSWERING);
      });
    }).catch(() => {
      notify('Avaliação não encontrada. Verifique o código informado.', 'warning');
    }).finally(() => {
      setSearching(false);
    });
  }, [getTestDetails, getTestAnswerKey, notify]);

  const handleSearch = useCallback(() => {
    const code = testCode.trim();
    if (!code || searching) return;
    searchByCode(code);
  }, [testCode, searching, searchByCode]);

  const handleSaved = useCallback((savedResult) => {
    setResult(savedResult);
    setPhase(Phase.SUCCESS);
  }, []);

  useEffect(() => {
    const code = new URLSearchParams(location.search).get('code');
    if (!code) return;
    setTestCode(code);
    searchByCode(code.trim());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className={classes.root}>
      <Typography variant="h5" className={classes.title}>Correção de Avaliação</Typography>

      {phase === Phase.SEARCH && (
        <SearchStep
          testCode={testCode}
          onTestCodeChange={setTestCode}
          onSearch={handleSearch}
          searching={searching}
        />
      )}

      {phase === Phase.BLOCKED && (
        <BlockedStep testInfo={testInfo} onBack={resetToSearch} />
      )}

      {phase === Phase.ANSWERING && (
        <AnsweringStep
          testCode={testCode.trim()}
          testInfo={testInfo}
          answerKey={answerKey}
          onChangeCode={resetToSearch}
          onSaved={handleSaved}
        />
      )}

      {phase === Phase.SUCCESS && (
        <SuccessStep
          studentName={testInfo?.studentName}
          result={result}
          fallbackTotalQuestions={answerKey.length}
          onReset={resetToSearch}
        />
      )}
    </Box>
  );
}
